import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translateNumber',
  standalone: false
})
export class TranslateNumberPipe implements PipeTransform {
  transform(val: number, language: string, currency?: string, maximumFractionDigits = 0): Intl.NumberFormat | string {
    let formatConfig = {};

    if (currency) {
      formatConfig = {
        style: 'currency',
        currency,
        currencyDisplay: 'symbol',
        maximumFractionDigits
      };
    } else {
      formatConfig = {
        maximumFractionDigits
      };
    }
    const formatter = new Intl.NumberFormat(language, formatConfig);
    return formatter.format(val);
  }
}
